import {
  EfsMelcoEfsModelsFormat,
  Drawer as DrawerType,
} from "melco-shared-logic";
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { FilenameRuleForm } from "./FilenameRuleForm";

type FilenameRuleDrawerProps = {
  drawer: DrawerType;
  inputFormat: EfsMelcoEfsModelsFormat;
  editFilenameRuleIndex: number | undefined;
};

export type FilenameRuleFormMode = "add" | "edit";

export const FilenameRuleDrawer: React.FC<FilenameRuleDrawerProps> = ({
  drawer,
  editFilenameRuleIndex,
}) => {
  const { t } = useTranslation();

  const { closeDrawer, isDrawerOpen } = drawer;

  const isAddingNewRule = editFilenameRuleIndex == null;

  const formMode = isAddingNewRule ? "add" : "edit";

  return (
    <Drawer
      title={t(`inputFormats.actions.filenameRules.actions.${formMode}.title`)}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
    >
      <FilenameRuleForm
        drawer={drawer}
        editFilenameRuleIndex={editFilenameRuleIndex}
        formMode={formMode}
      />
    </Drawer>
  );
};
